// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"1a6f04d3","157":"b5273d34"}[chunkId] + ".chunk.js";
};